// function anch() {
// 	const anchors = document.querySelectorAll('.header--menu a');
//
// 	for (let anchor of anchors) {
// 		anchor.addEventListener('click', function(e) {
// 			e.preventDefault();
//
// 			const blockID = anchor.getAttribute('href').substr(1);
//
// 			document.getElementById(blockID).scrollIntoView({
// 				behavior: 'smooth',
// 				block: 'start'
// 			});
// 		});
// 	}
// }

const resizeMenu = () => {
	let menu = document.querySelector('.header--menu'),
		mobileWrap = document.querySelector('.header--menu-main');
	mobileWrap.append(menu.cloneNode(true));
};

// eslint-disable-next-line no-unused-vars
const toggleMobileMenu = (btn) => {
	let menu = document.querySelector('.header--menu-mobile');
	btn.classList.toggle('active');
	menu.classList.toggle('active');
	document.querySelector('header').classList.toggle('active');
	document.querySelector('html').classList.toggle('no_scroll');
	document.body.classList.toggle('no_scroll');
};


let mask = '';
const initMask = () => {
	let element = document.querySelectorAll('.phone--mask'),
		maskOptions = {
			mask: '+{7} ( 000 ) 000 - 00 - 00'
		};
	Array.from(element).map(el => {
		// eslint-disable-next-line no-undef
		mask = IMask(el, maskOptions);
	});
};

const validForm = () => {
	let form = document.getElementById('footer--form'),
		phone = document.getElementById('phone');
	const valid = () => {
		if (mask.unmaskedValue.length !== 11) {
			phone.nextElementSibling.classList.add('visible');
			phone.classList.add('error');
		} else {
			phone.nextElementSibling.classList.remove('visible');
			phone.classList.remove('error');
		}
	};
	phone.addEventListener('keyup', () => {
		valid();
	});

	form.addEventListener('submit', () => {
		event.preventDefault();
		valid();
	});
};

// eslint-disable-next-line no-unused-vars
const showTags = (btn, tag) => {
	let blocks = document.querySelectorAll('.portfolio--block'),
		btns = document.querySelectorAll('.portfolio--tabs button');

	Array.from(btns).map(el => {
		el !== btn ? el.classList.remove('active') : el.classList.add('active');
	});

	if (!tag) {
		Array.from(blocks).map(el => {
			el.classList.remove('hidden');
		});
	} else {
		Array.from(blocks).map(el => {
			let data = el.dataset.tags.split(',');
			if (data.indexOf(String(tag)) === -1) {
				el.classList.add('hidden');
			} else {
				el.classList.remove('hidden');
			}
		});
	}
};

// eslint-disable-next-line no-unused-vars
const changeTab = (btn, index, full = false) => {
	let tabs = document.querySelectorAll('.integration--tab'),
		btns = document.querySelectorAll('.integration--tabs button');

	if(full) {
		const blocks = document.querySelectorAll('.integration--bottom-wrap');
		Array.from(blocks).map(el => {
			+el.dataset.tab === index ? el.classList.add('active') : el.classList.remove('active');
		});

	}

	Array.from(tabs).map(el => {
		+el.dataset.tab === index ? el.classList.add('active') : el.classList.remove('active');
	});

	Array.from(btns).map(el => {
		el === btn ? el.classList.add('active') : el.classList.remove('active');
	});
};

function getPreloader() {
	return '<svg class="btn--preloader" width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
    '        <circle class="center" r="12.5" cx="15" cy="15" stroke-width="3" stroke="white" stroke-opacity="0.25" />\n' +
    '        <circle class="progress" id="pr1" r="12.5" cx="15" cy="15" stroke-width="3" stroke="#ffffff" stroke-dasharray="0, 78.53981633974483" />\n' +
    '    </svg>';
}

function resetProgress(el, rd, callback = () => {
}) {
	el.setAttribute('style', 'transition: none;');
	let i = 0;
	let a = 0;
	let x = rd * 2 * Math.PI;
	a = i / 100;
	let p = x * a;
	el.setAttribute('stroke-dasharray', p + ', ' + x);
	setTimeout(() => {
		callback();
	}, 10);
}

function radialProgress(update, id) {
	let el = document.querySelector('.progress');
	let rd = document.getElementById(id).getAttribute('r');
	let i = 0;
	let a = 0;
	let x = rd * 2 * Math.PI;
	resetProgress(el, rd, () => {
		el.removeAttribute('style');
		i = update;
		a = i / 100;
		let p = x * a;
		el.setAttribute('stroke-dasharray', p + ', ' + x);
		el.setAttribute('stroke', '#ffffff');
	});

}

resizeMenu();

// eslint-disable-next-line no-unused-vars
function doGlobalBtn(btn) {
	window.currentButton = btn;
}

let loader = false,
	tick = 0;

function loaderFn() {
	let preloader = document.querySelector('.progress'),
		time = 2,
		percentTime = 0;

	function startPreloader() {
		clearTimeout(tick);
		tick = setInterval(interval, 25);
	}

	function interval() {
		let rlen = 2 * Math.PI * preloader.getAttribute('r');
		preloader.setAttribute('style', `stroke-dasharray: ${rlen}px;stroke-dashoffset: ${rlen}px`);
		percentTime += 1 / (time + 0.1);
		preloader.setAttribute('style', `stroke-dasharray: ${rlen}px;stroke-dashoffset: ${rlen * (1 - percentTime / 100)}px`);
		if (percentTime >= 100) {
			percentTime = 0;
			startPreloader();
		}
	}

	if (loader === false) {
		loader = true;
		startPreloader();
	} else {
		clearTimeout(tick);
		loader = false;
	}

}

function errorMessage(message) {
	let errorWrap = document.querySelector('.fixed--message-holder'),
		textHolder = document.getElementById('message_holder');
	textHolder.innerHTML = message;
	errorWrap.classList.add('active');
	setTimeout(() => {
		errorWrap.classList.remove('active');
	}, 5000);
}


function doPreloader(btn, status = true) {
	if (!status) {
		btn.querySelector('svg').remove();
		btn.classList.remove('loading');
		clearTimeout(tick);
	} else {
		const preloader = getPreloader();
		btn.classList.add('loading');
		btn.insertAdjacentHTML('beforeend', preloader);
		setTimeout(() => {
			loaderFn();
		}, 10);
	}
}

document.addEventListener('DOMContentLoaded', () => {
	validForm();
	initMask();
	if (typeof SmoothScroll !== 'undefined')
	// eslint-disable-next-line no-unused-vars,no-undef
		var scroll = new SmoothScroll('a[href*="#"]');
});
